// faq definitions
export const faqItems = [
  {
    id: 1,
    q: "How do you view data points on the map?",
    a: /*html*/ `Click on the name of a theme in the Layers tab in the main menu
     to view available data layers. Click the toggle switch to the right of the
      layer name to add it to the map.`,
  },
  {
    id: 2,
    q: "How do you zoom to a particular area on the map?",
    a: /*html*/ `Use the scroll wheel on your mouse or the plus (+) and minus
    (-) buttons in the lower left corner of the map.`,
  },
  {
    id: 3,
    q: "How do you change the region of interest?",
    a: /*html*/ `Click and drag the map to change the current extent.
    Additionally, the Filters tab in the main menu allows you to select data by
    geographic boundary.`,
  },
  {
    id: 4,
    q: "What do the colors and symbols on the map represent?",
    a: /*html*/ `Colors and symbols used in the map are defined in the Legend
    tab of the main menu.`,
  },
];
